<template>
<!--
    @todo Needs a serious refactor in here. This component was added very quickly to deal with an issue
    with render speed for Tower who had 2000 requests in their request list. So we moved the code
    in to a sub-component, which reduced the redraw, but we left all the function references pointing
    to the parent component, and left the functions in the parent. Need to check which functions
    used in this component are only actually needed in here (most of them probably) and then
    move them to this component, and remove the "$parent.$parent." reference from the calls. Note
    that the double $parent reference is because of the way ListBase and ListBaseTemplate work.
-->
    <li v-on:click='openThread()' :key='item.id' :class='"list-thread_item " + extClass'>
                            
        <!-- ID: {{item.id}}<br /> -->
        <!-- @updatehere -->
        <!-- <h2 class="h6">{{item.id}}</h2> -->
        <span class="status status-primary"></span>


        <div class='list-flags' :class="$parent.$parent.getPriorityClass(item)">
            <span v-if='$parent.$parent.is_archived(item)' :title="$t('translations.archived')" v-html="$t('translations.archived')" class="icon icon-archived"></span>
            <span v-else-if='$parent.$parent.is_closed(item)' :title="$t('translations.closed')" v-html="$t('translations.closed')" class="icon icon-closed"></span>
            <template v-else>
                <span v-if='$parent.$parent.is_unassigned(item)' :title="$t('translations.new')" class="icon icon-unassigned"></span>
                <span v-if='$parent.$parent.is_assignedToMe(item)' :title='$parent.$parent.assignee_name(item)' v-html="$t('translations.mine')" class="icon icon-mine"> </span>
                <span v-else-if='$parent.$parent.is_assignedToMyGroups(item)' :title='$parent.$parent.assignee_name(item)' v-html="$t('translations.mine')" class="icon icon-my-group"> </span>
                <span v-else-if='$parent.$parent.is_assigned(item)' :title='$parent.$parent.assignee_name(item)' v-html="$t('translations.assigned')" class="icon icon-assigned"> </span>
            </template>
            <!-- <span v-if='new_message(item)' title='Unread messages' class="icon icon-unread"></span> -->
            <template v-if='!$parent.$parent.is_archived(item)'>
                <span v-if='$parent.$parent.is_patient() && $parent.$parent.new_message(item)' :title="$t('translations.unread_messages')" class="icon icon-unread"></span>
                <template v-if='$parent.$parent.is_staff()'>
                    <template v-if='$parent.$parent.has_unread_response(item)'>
                        <span v-if='$parent.$parent.new_message(item)' :title="autobrand('translations.new_message_patient_unread')" class="icon icon-patient-unread-new">UN</span>
                        <span v-else :title="autobrand('translations.patient_unread')" class="icon icon-patient-unread">U</span>
                    </template>
                    <template v-else-if='$parent.$parent.patient_read_all(item)'>
                        <span v-if='$parent.$parent.new_message(item)' :title="autobrand('translations.new_message_patient_read_all')" class="icon icon-patient-read-new">RAN</span>
                        <span v-else :title="autobrand('translations.patient_read_all')" class="icon icon-patient-read">RA</span>
                    </template>
                    <span v-else-if='$parent.$parent.new_message(item)' title='Unread messages' class="icon icon-unread"></span>

                    <!-- <span v-if='staff_has_responded(item)' title='Patient has received a response' class="icon icon-staff-responded">R</span> -->
                    <!-- <span v-else title='Patient has not received a response' class="icon icon-staff-not-responded">NR</span>-->
                </template>
            </template>
        </div>

        <div class="d-flex flex-wrap thread-meta">
            <template v-if='item.user'>
                <h2 class="h6 mr-1">{{formatSurname(item.user)}} <template v-if='item.user.gender || item.user.dob'>(<template v-if='item.user.gender'>{{item.user.gender.toUpperCase()}}</template><template v-if='item.user.gender && item.user.dob'>&nbsp;</template><template v-if='item.user.dob'>{{item.user.dob | getAge}}</template>)</template></h2>
            </template>
            <template v-if='$parent.$parent.isCurrentRequestFilter()'>
                <div v-if='userHasOther(item.user) > 1' :title="autobrand('translations.number_open_requests_for_patient')" v-on:click.stop='$emit("user-filter", item.user)' class="badge badge-info ml-auto" style='line-height: 1; cursor: zoom-in;'>{{ userHasOther(item.user) }}</div>
            </template>
            <!-- <template v-else-if='reportError("Missing user in thread", item)'>
            </template> -->
            <!-- <template v-if='reportError("Testing", item)'>
            </template> -->
        </div>

        <div v-if='item.created_by && item.created_by != item.user_id' class="d-flex align-items-start" style="padding-bottom: 5px;">
            <p class="thread-createdby">
                {{ $t('translations.created_by')}}: {{formatSurname(item.created_by_user)}}
            </p>
            <template v-if='$parent.$parent.isCurrentRequestFilter()'>
                <div title='Number of open requests created by this user' v-on:click.stop='$emit("created-by-user-filter", item.created_by_user)' class="badge badge-info ml-auto" style='cursor: zoom-in; font-size: 10.8px' v-if='createdByHasOther(item.created_by_user) > 1'>{{ createdByHasOther(item.created_by_user) }}</div>
            </template>
        </div>
    
        
        <p class="subject">{{(item.question_group && item.question_group.question_group_type_id == 1) ? $t('translations.qa_in_progress') : ""}} {{item.subject ? item.subject.substring(0,100) : "[" + $t('translations.no_subject') + "]"}}</p>

        <span class="time-stamp" style='line-height: 1.2'>{{item.created_at| formatDateTime}}</span>

        <div>
            <template v-for='(tag) in $parent.$parent.getTags(item)'>
                <div :key='"t-" + tag.tag_id' v-if='getTag(tag.tag_id).name' class='search-lozenge-thin badge badge-primary badge-pill' :style="{'background-color': getTag(tag.tag_id).colour}">
                    <i :class='"pr-1 fa fa-lg fa-" + getTag(tag.tag_id).icon' /> {{ getTag(tag.tag_id).name }}
                </div>
            </template>

            <template v-if="item.originating_provider && item.originating_provider_id != $root.provider.id">
                <div v-on:clickx='$parent.$parent.source_id = `provider_${item.originating_provider_id}`' title='Origin' :key='`orp-${item.originating_provider_id}`' class='search-lozenge-thin badge-wrap badge-primary badge-pill' :xstyle="{'background-color': '#4020a0'}">
                    <i :class='"pr-1 fa fa-lg fa-solid fa-arrow-up"' /> {{ item.originating_provider.name }}
                </div>
            </template>
            <template v-if="item.owner_provider && item.owner_provider_id != $root.provider.id && item.owner_provider_id != item.originating_provider_id">
                <div v-on:clickx='$parent.$parent.source_id = `provider_${item.owner_provider_id}`' title='Owner' :key='`op-${item.owner_provider_id}`' class='search-lozenge-thin badge-wrap badge-primary badge-pill' :xstyle="{'background-color': '#4020a0'}">
                    <i :class='"pr-1 fa fa-lg fa-solid fa-arrow-right"' /> {{ item.owner_provider.name }}
                </div>
            </template>
            <template v-if="item.last_transferred_from_provider && item.last_transferred_from_provider_id != $root.provider.id && item.last_transferred_from_provider_id != item.originating_provider_id">
                <div v-on:clickx='$parent.$parent.source_id = `provider_${item.last_transferred_from_provider_id}`' title='Transferred from' :key='`ltf-${item.last_transferred_from_provider_id}`' class='search-lozenge-thin badge-wrap badge-primary badge-pill' :xstyle="{'background-color': '#609010'}">
                    <i :class='"pr-1 fa fa-lg fa-share"' /> {{ item.last_transferred_from_provider.name }}
                </div>
            </template>
        </div>        

    </li>
</template>


<script>
	export default {
		props: {
            item: {
                
            },
            inclass: {

            }
        },
		data: function(){
			return {
                extClass: this.$route.params.id == this.item.id ? "router-link-exact-active router-link-active" : "",
			};
		},
        mounted() {
        },
		computed: {

		},
		watch: {
            "$route.params.id": function(newId, oldId) {
                //console.log("HERE", oldId, oldId, this.item.id);
                if(oldId == this.item.id) {
                    //console.log("REMOVING");
                    this.extClass="";
                }
                if(newId == this.item.id) {
                    //console.log("SETTING");
                    this.extClass="router-link-exact-active router-link-active";
                }

            }
		},
		methods: {
            openThread() {
                var route = (this.$parent.$parent.subroute ? "/" + "thread-list" : "") + "/" + "thread-show/" + this.item.id + (this.$parent.$parent.is_archived(this.item) ? "/1" : "");
                if(route != this.$route.path) {
                    this.$router.push({path: route})
                }
            },
            userHasOther(user) {
                return this.$root.userHasOther[user.id];
            },
            createdByHasOther(created_by_user) {
                return this.$root.createdByHasOther[created_by_user.id];
            },
        }
	}
</script>